<script>
import SimpleTopCategories from '@rei/simple-top-categories';

export default {
  name: 'CouponCategories',
  components: {
    SimpleTopCategories,
  },
  props: {
    heading: { type: String, required: false, default: '' },
    categories: { type: Array, required: false, default: () => [] },
  },
  computed: {
    categoriesProps() {
      return {
        categories: this.categories,
        mediaConfig: {
          hasBackground: false,
          padding: {
            mobile: 0,
            desktop: 0,
          },
        },
      };
    },
  },
};
</script>
<template>
  <div>
    <h2
      v-if="heading"
      class="coupon-categories__heading"
      v-html="heading"
    />
    <simple-top-categories
      v-bind="categoriesProps"
    />
  </div>
</template>
<style lang="scss">
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';
.coupon-categories {
  &__heading {
    @include cdr-text-heading-serif-500;
    margin: 0 0 $cdr-space-two-x;

    @include cdr-sm-mq-up {
      @include cdr-text-heading-serif-600;
      text-align: center;
    }
  }
}
</style>
